var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "item" }, [
    _c(
      "div",
      { staticClass: "item--body" },
      [
        _vm._t("header"),
        _vm._v(" "),
        _vm.isShowingFullArticle
          ? _c("div", [_vm._t("content")], 2)
          : _c("div", [_vm._t("excerpt")], 2),
        _vm._v(" "),
        _c("a", { staticClass: "read-more", attrs: { href: _vm.permalink } }, [
          _c("span", [_vm._v("Read more")]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "item--image-wrapper" }, [
      _c("a", { attrs: { href: _vm.permalink } }, [
        _c("img", {
          staticClass: "image-thumb",
          attrs: { alt: "", src: _vm.imageUrl },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/BlogPost.vue